import React from "react";
import GetInTouch from "../Home/GetInTouch";
import ArrowRightIcon from "../../assets/svg/arrow-right-white.svg";
import AboutUsImage from "../../assets/images/about-us.png";
import WhyChooseImage from "../../assets/images/why-choose.png";
import Team1Image from "../../assets/images/team-1.png";
import Team2Image from "../../assets/images/team-2.png";
import Team3Image from "../../assets/images/team-3.png";
import Team4Image from "../../assets/images/team-4.png";
import OurTeamCarousel from "./OurTeamCarousel";

const AboutUs = () => {
  return (
      <>
          <div className="about-us pb_100 pt_100">
              <div className="container">
                  <div className="row align-items-center">
                      <div className="col-lg-6">
                          <div className="about-content">
                              <h5 className={'fs_40 fw_700 mb_10 text-color'}>About Moolchandji Foods</h5>
                              <h6 className={'fs_20 fw_600 mb_20 text-color'}>Freshly Ground. Purely Yours.</h6>
                              <p className={'fs_20 fw_400 mb_18 text-color lh-1-5'}>
                                  At <strong>Moolchandji Foods</strong>, we are redefining the way families consume flour. Instead of relying on months-old packaged atta, we freshly grind your flour only after you place an order, ensuring unmatched freshness, aroma, and nutrition.
                              </p>

                              <p className={'fs_20 fw_400 mb_58 text-color lh-1-5'}>
                                  Using our low RPM stone grinding technology, we preserve the natural goodness of every grain while allowing you to fully customize your flour with healthy grains, millets, and seeds. From our mill to your kitchen, every pack is prepared with care and delivered fresh to your doorstep.
                              </p>

                              <button className={'button icon btn-solid'}>
                                  Customize Your Flour
                                  <img src={ArrowRightIcon} alt="arrow icon"/>
                              </button>
                          </div>
                      </div>
                      <div className="col-lg-6">
                          <div className="img-wrapper text-end">
                              <img src={AboutUsImage} alt="about us image"/>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div className="why-choose-us text-start">
              <div className="container">
                  <div className="row">
                      <div className="col-md-5 order-lg-1 order-2">
                          <div className="img-wrapper">
                              <img src={WhyChooseImage} alt="Why Choose Image"/>
                          </div>
                      </div>

                      <div className="col-md-7 order-lg-2">
                          <div className="why-chose-us-content ms-auto text-start">
                              <h5 className={'fs_40 fw_700 text-color mb_20'}>Why Choose Us?</h5>

                              <div className={'mb_20'}>
                                  <h6 className={'fs_20 fw_500 text-color mb_12'}>🌾 Freshly Ground on Every Order</h6>
                                  <p className={'fs_20 fw_400 lh-1-5 text-color mb-0'}>Unlike packaged flour, we grind only after you order so every meal starts with fresh, aromatic flour.</p>
                              </div>

                              <div className={'mb_20'}>
                                  <h6 className={'fs_20 fw_500 text-color mb_12'}>🪨 Low RPM Stone Grinding</h6>
                                  <p className={'fs_20 fw_400 lh-1-5 text-color mb-0'}>Our traditional low RPM grinding process preserves natural nutrients, fiber, and authentic taste.</p>
                              </div>

                              <div className={'mb_20'}>
                                  <h6 className={'fs_20 fw_500 text-color mb_12'}>🥣 Fully Customized Flour</h6>
                                  <p className={'fs_20 fw_400 lh-1-5 text-color mb-0'}>Mix wheat with ragi, barley, oats, flaxseed, chana, soyabean and many more ingredients exactly as your family prefers.</p>
                              </div>

                              <div>
                                  <h6 className={'fs_20 fw_500 text-color mb_12'}>🚚 Fresh Delivery</h6>
                                  <p className={'fs_20 fw_400 lh-1-5 text-color mb-0'}>Every order is packed immediately after grinding and delivered fresh to your home.</p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          {/* <div className="mt_100">
              <div className="container">
                  <div className="row text-center">
                      <div className="col-md-3">
                          <h2 className="fw_700 fs_48 text-color">100%</h2>
                          <p>Fresh Grinding</p>
                      </div>

                      <div className="col-md-3">
                          <h2 className="fw_700 fs_48 text-color">0%</h2>
                          <p>Preservatives</p>
                      </div>

                      <div className="col-md-3">
                          <h2 className="fw_700 fs_48 text-color">Low RPM</h2>
                          <p>Stone Grinding</p>
                      </div>

                      <div className="col-md-3">
                          <h2 className="fw_700 fs_48 text-color">Doorstep</h2>
                          <p>Fresh Delivery</p>
                      </div>
                  </div>
              </div>
          </div> */}

          <div className="vision-box mt_100 py_60">
              <div className="container">
                  <div className="row">
                      <div className="col-md-6">
                          <div className="content pb_48 our-vision">
                              <h5 className={'fs_40 fw_700 mb_20 text-white text-capitalize'}>Our Vision</h5>
                              <p className={'fs_20 fw_400 mb-0 lh-1-5 text-white text-capitalize'}>To become India's most trusted fresh flour brand by combining traditional stone grinding with modern technology, making healthy eating convenient for every family.</p>
                          </div>
                      </div>

                      <div className="col-md-6">
                          <div className="content our-promise pl_40 pb_48 h-100">
                              <h5 className={'fs_40 fw_700 mb_20 text-white text-capitalize'}>Our Promise</h5>
                              <p className={'fs_20 fw_400 mb-0 lh-1-5 text-white text-capitalize'}>We promise complete transparency. The grains you select are the grains we grind. No preservatives, no mixing, and no shortcuts. Just pure, freshly milled flour prepared with honesty and care.</p>
                          </div>
                      </div>

                      <div className="col-12">
                          <div className="content text-lg-center mt_48 pb-0">
                              <h5 className={'fs_40 fw_700 mb_20 text-white text-capitalize'}>Bringing Back the Taste of Real Flour</h5>
                              <p className={'fs_20 fw_400 mb-0 lh-1-5 text-white text-capitalize'}>At Moolchandji Foods, we believe healthy food begins with fresh ingredients. Our mission is to combine the wisdom of traditional stone grinding with the convenience of modern technology, so every family can enjoy pure, nutritious, and freshly milled flour without compromise.</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div className="our-team py_100">
              <div className="container">
                  <div className="row g-4">
                      <div className="col-md-12">
                          <div className="team-section-title text-center">
                              <p className={'fs_20 lh-1-5 fw_400 text-color mb_8'}>THE PEOPLE BEHIND THE PROMISE</p>
                              <h2 className={'fs_40 fw_700 mb_60 text-color lh-1'}>Meet the Team Behind Moolchandji Foods</h2>
                          </div>
                      </div>

                      <div className="col-12">
                          <OurTeamCarousel />
                      </div>
                  </div>
              </div>
          </div>

          <GetInTouch />
      </>
  );
};

export default AboutUs;
